// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__29k1O","legacyBtn":"MutateMid_legacyBtn__21aGb"};